<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-combobox v-model="current_champ.value" :items="items" :loading="loading"
      :disabled="current_champ.disabled || is_disable" :auto-select-first="false" hide-no-data ref="field"
      @update:search="onSearchInput" @change="verify_input(current_champ)" @blur="$refs.field.validate()"
      :hint="get_hint" density="compact"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-combobox>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";

export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
      items: [],
      loading: false,
      debounceTimer: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    get_hint() {
      if (this.current_champ.nom == "club") {
        return "Accepté : Majuscules, chiffres, espaces et certains caractères spéciaux";
      }
      return "";
    },
    id_module() {
      return this.mainStore.module?.id || this.inscription?.id_module;
    },
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },
  methods: {
    onSearchInput(search) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchSuggestions(search ?? "");
      }, 200);
    },

    getLocalSuggestions(search) {
      const inscriptions = this.mainStore.bookingSystem?.booking?.inscriptions ?? [];
      const searchLower = (search ?? "").trim().toLowerCase();
      const suggestions = [];

      for (let i = 0; i < inscriptions.length; i++) {
        const ins = inscriptions[i];
        if (ins === this.inscription) continue;

        const value = ins.coureur?.champs?.[this.current_champ.nom]?.value;
        if (!value || typeof value !== "string") continue;

        const trimmed = value.trim();
        if (!trimmed) continue;
        if (searchLower && !trimmed.toLowerCase().includes(searchLower)) continue;

        suggestions.push(trimmed);
      }

      return suggestions;
    },

    mergeSuggestions(localSuggestions, apiSuggestions) {
      const seen = new Set();
      const merged = [];

      const addValue = (value) => {
        const trimmed = (value ?? "").trim();
        if (!trimmed) return;
        const key = trimmed.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        merged.push(trimmed);
      };

      localSuggestions.forEach(addValue);
      (apiSuggestions ?? []).forEach(addValue);

      merged.sort((a, b) => a.localeCompare(b, "fr", { sensitivity: "base" }));
      return merged.slice(0, 20);
    },

    async fetchSuggestions(search) {
      const localSuggestions = this.getLocalSuggestions(search);
      this.loading = true;

      try {
        const apiSuggestions = await PublicService.getChampSuggestions(
          this.id_module,
          this.current_champ.nom,
          search ?? ""
        );
        this.items = this.mergeSuggestions(localSuggestions, apiSuggestions);
      } catch (error) {
        this.items = this.mergeSuggestions(localSuggestions, []);
      } finally {
        this.loading = false;
      }
    },

    verify_input(champ) {
      this.verify_change_identity_current_coureur(champ.nom);
      this.reformat_field(champ);
    },
    verify_change_identity_current_coureur(champ) {
      let identity_champs = ["nom", "prenom", "date_naissance", "sexe"];
      if (identity_champs.includes(champ) && this.inscription.coureur.id != null) {
        this.$emit("change_identity_coureur", this.inscription.coureur);
      }
    },
    reformat_field(champ) {
      if (champ.nom == "nom") {
        champ.value = champ.value.toUpperCase();
      }
      if (champ.nom == "club") {
        champ.value = champ.value.toUpperCase();
      }
      if (champ.nom == "prenom") {
        champ.value = champ.value.replace(/(?:^|[\s-])\S/g, (c) => c.toUpperCase());
      }
    },
  },
  created() {
    this.current_champ = this.champ;
  },
  beforeUnmount() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },
};
</script>

<style lang="scss"></style>
